export default __webpack_public_path__ + "8ae5f2c46939f406a2283eb8b26678fe.png";